(() => {
  const selector = 'popup-component[data-shipping-notice]';

  const open = (popup) => {
    customElements.upgrade(popup);

    const dialog = popup.querySelector('dialog');
    if (!dialog || dialog.hasAttribute('open')) return;

    if (typeof popup.popupOpen === 'function') popup.popupOpen();
  };

  const openNotices = () => {
    document.querySelectorAll(selector).forEach((popup) => {
      if (popup.dataset.shippingNoticeOpened === 'true') return;
      popup.dataset.shippingNoticeOpened = 'true';
      open(popup);
    });
  };

  const run = () => {
    customElements.whenDefined('popup-component').then(() => requestAnimationFrame(openNotices));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
